import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "items-center justify-between flex" }
const _hoisted_3 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex gap-3" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_10 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_11 = { class: "pr-5" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "lg:flex" }
const _hoisted_14 = { class: "lg:w-1/2" }
const _hoisted_15 = {
  key: 0,
  class: "w-full h-full flex justify-center items-center"
}
const _hoisted_16 = {
  key: 0,
  id: "chart"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "lg:w-1/2 topPaddingForTable" }
const _hoisted_19 = { class: "tableCornerRadius w-85" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 1,
  class: "flex"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "table-ellipsis" }
const _hoisted_25 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_26 = { class: "flex flex-row" }
const _hoisted_27 = { class: "w-6/12" }
const _hoisted_28 = {
  class: "text-sm mt-2",
  style: {"display":"inline-block"}
}
const _hoisted_29 = {
  class: "text-sm",
  style: {"display":"inline-block"}
}
const _hoisted_30 = { class: "mt-3" }
const _hoisted_31 = { class: "flex flex-row" }
const _hoisted_32 = { class: "w-6/12" }
const _hoisted_33 = { class: "text-sm mt-2" }
const _hoisted_34 = { class: "w-6/12" }
const _hoisted_35 = { class: "text-sm mt-2" }
const _hoisted_36 = { class: "mt-3" }
const _hoisted_37 = { class: "flex flex-row" }
const _hoisted_38 = { class: "w-6/12" }
const _hoisted_39 = { class: "text-sm mt-2" }
const _hoisted_40 = { class: "w-3/6" }
const _hoisted_41 = { class: "text-sm mt-2" }
const _hoisted_42 = { class: "mt-3" }
const _hoisted_43 = { class: "flex flex-row" }
const _hoisted_44 = { class: "w-1/2" }
const _hoisted_45 = { class: "text-sm flex mt-2 flex-wrap" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = {
  key: 1,
  class: "h-6 bg-primary mr-3 px-2 rounded-sm flex items-center text-white text-sm"
}
const _hoisted_48 = { class: "w-1/2" }
const _hoisted_49 = { class: "text-sm flex mt-2 flex-wrap" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "" }
const _hoisted_52 = { class: "flex flex-row mt-3" }
const _hoisted_53 = { class: "w-6/12" }
const _hoisted_54 = { class: "text-sm flex mt-2 flex-wrap" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "w-6/12" }
const _hoisted_57 = { class: "text-sm flex mt-2 flex-wrap" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = {
  key: 3,
  class: "mt-5"
}
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_64 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_65 = { class: "formcontainer flex flex-col" }
const _hoisted_66 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_67 = { class: "w-6/12 pr-2" }
const _hoisted_68 = { class: "mt-2 text-sm" }
const _hoisted_69 = { class: "w-full mt-3" }
const _hoisted_70 = { class: "mt-2 text-sm" }
const _hoisted_71 = { class: "w-full mt-3" }
const _hoisted_72 = { class: "mt-2 text-sm" }
const _hoisted_73 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_74 = { class: "flex flex-col h-full" }
const _hoisted_75 = { class: "flex-1 overflow-auto" }
const _hoisted_76 = { class: "popup-business" }
const _hoisted_77 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_78 = { class: "formcontainer flex flex-col" }
const _hoisted_79 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_80 = { class: "w-full px-1" }
const _hoisted_81 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_82 = { class: "w-full px-1 flex" }
const _hoisted_83 = { class: "formcontainer flex justify-end pb-4 pl-5 pt-4 pr-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pt-3 pl-5 pr-5", { 'details-in-modal': _ctx.modalMode }])
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.modalMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.presentComplianceObject.title), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.showStartButton && _ctx.presentComplianceObject.statusCode == 10401)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startPresentCompliance())),
              class: "btnprimary"
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("div", null, "Start", -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.presentComplianceObject.statusCode && _ctx.presentComplianceObject.statusCode!= 10401 )
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startPresentCompliance())),
              class: "btnprimary"
            }, _cache[12] || (_cache[12] = [
              _createElementVNode("div", null, "Tasks", -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.presentComplianceObject.statusCode != 10418 && _ctx.tasksOpen && _ctx.presentComplianceObject.teamLeader.value==_ctx.userInfo._id)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onclickTerminate())),
              class: _normalizeClass([_ctx.tasksOpen == true ? 'btnprimary':'btndisabled', "btnprimary items-centy"])
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("div", null, "Terminate", -1)
            ]), 2))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex == 3 )
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              class: _normalizeClass(["flex", _ctx.teamsArray.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterOpenForAuditInfo && _ctx.filterOpenForAuditInfo(...args)))
            }, [
              (_ctx.teamsArray.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _cache[14] || (_cache[14] = _createTextVNode(" Filters "))
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex == 4)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filterOpenForFindings && _ctx.filterOpenForFindings(...args)))
            }, [
              (_ctx.tableRow.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : (_openBlock(), _createElementBlock("img", _hoisted_9)),
              _cache[15] || (_cache[15] = _createTextVNode(" Filters "))
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Tabs, {
          value: _ctx.selectedTabIndex,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
          scrollable: "",
          lazy: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TabList, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                  return (_openBlock(), _createBlock(_component_Tab, {
                    key: tab.id,
                    value: tab.id,
                    onClick: ($event: any) => (_ctx.toggleTabs(tab))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.displayName), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "onClick"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanels, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabPanel, {
                    key: tab.id,
                    value: tab.id
                  }, {
                    default: _withCtx(() => [
                      (tab.id == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                (_ctx.series.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      (_ctx.presentComplianceObject.statusCode != 10401)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createVNode(_component_apexchart, {
                                              type: "pie",
                                              width: "380",
                                              options: _ctx.chartOptions,
                                              onDataPointSelection: _ctx.clickOnPieLabel,
                                              series: _ctx.series
                                            }, null, 8, ["options", "onDataPointSelection", "series"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.presentComplianceObject.statusCode == 10401)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[16] || (_cache[16] = [
                                            _createElementVNode("p", { class: "text-xs font-normal" }, "Compliance Not Started Yet", -1)
                                          ])))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("table", null, [
                                    _createElementVNode("thead", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (column) => {
                                        return (_openBlock(), _createElementBlock("th", {
                                          scope: "col",
                                          key: column,
                                          class: _normalizeClass([_ctx.getColumnHeadWidth(column), "bg-white th1 cursor-pointer capitalize"])
                                        }, [
                                          (column == 'taskStatus')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[17] || (_cache[17] = [
                                                _createElementVNode("div", null, _toDisplayString(''), -1)
                                              ])))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _createElementVNode("div", null, _toDisplayString(column), 1)
                                              ]))
                                        ], 2))
                                      }), 128))
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewComplianceObj, (row, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: index,
                                          class: "rowHeight"
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (presentColumn) => {
                                            return (_openBlock(), _createElementBlock("th", {
                                              key: presentColumn,
                                              class: "cursor-pointer relative"
                                            }, [
                                              (presentColumn == 'status')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(_ctx.textColor(row['taskStatus']))
                                                    }, _toDisplayString(_ctx.taskStatusCodes.find((l)=>{
                                                                        return  l.id == row['taskStatus']
                                                                    }).value), 3)
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(presentColumn == 'tasks'?'pl-3':'')
                                                      }, _toDisplayString(row[presentColumn]), 3)
                                                    ])
                                                  ]))
                                            ]))
                                          }), 128))
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-xs flex pt-2 mb-4 flex items-center justify-center" }, [
                                  _createElementVNode("p", { class: "font-semibold text-darkred" }, "*Note : "),
                                  _createTextVNode(" To close the Compliance All Tasks should be in completed state.")
                                ], -1))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (tab.id==2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Compliance period", -1)),
                                      _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                                      _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.changeDateFormat(_ctx.presentComplianceObject.period.fromDate) != undefined ?  _ctx.changeDateFormat(_ctx.presentComplianceObject.period.fromDate) : 'N/A'), 1),
                                      _cache[21] || (_cache[21] = _createTextVNode(" - ")),
                                      _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.changeDateFormat(_ctx.presentComplianceObject.period.toDate) != undefined ?  _ctx.changeDateFormat(_ctx.presentComplianceObject.period.toDate) : 'N/A'), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                      _cache[22] || (_cache[22] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Compliance Start Date", -1)),
                                      _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.changeDateFormat(_ctx.presentComplianceObject.startDate) != undefined ? _ctx.changeDateFormat(_ctx.presentComplianceObject.startDate) : 'N/A'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Compliance End Date", -1)),
                                      _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.changeDateFormat(_ctx.presentComplianceObject.endDate) != undefined ? _ctx.changeDateFormat(_ctx.presentComplianceObject.endDate) : 'N/A'), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _cache[24] || (_cache[24] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Compliance Title", -1)),
                                      _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.presentComplianceObject.title != undefined ? _ctx.presentComplianceObject.title : 'N/A'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_40, [
                                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Compliance Id", -1)),
                                      _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.presentComplianceObject.complianceId != undefined ? (_ctx.presentComplianceObject.complianceId).toUpperCase() : 'N/A'), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Compliance Lead", -1)),
                                      _createElementVNode("div", _hoisted_45, [
                                        (_ctx.teamLeaderLabel == '' || _ctx.teamLeaderLabel == undefined || _ctx.teamLeaderLabel == null)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, "N/A"))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.teamLeaderLabel), 1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Frameworks (Maximum 3 Frameworks )", -1)),
                                      _createElementVNode("div", _hoisted_49, [
                                        (_ctx.presentComplianceObject.frameworks == '' || _ctx.presentComplianceObject.frameworks == [] || _ctx.presentComplianceObject.frameworks == undefined || _ctx.presentComplianceObject.frameworks == null)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, "N/A"))
                                          : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentComplianceObject.frameworks, (eachFramework) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "w-auto h-6 bg-primary mr-3 px-2 rounded-sm flex items-center text-white text-sm",
                                            key: eachFramework
                                          }, _toDisplayString(eachFramework), 1))
                                        }), 128))
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("div", null, [
                                        _cache[28] || (_cache[28] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Location", -1)),
                                        _createElementVNode("div", _hoisted_54, [
                                          (_ctx.presentComplianceObject.location == '' || _ctx.presentComplianceObject.location == [] || _ctx.presentComplianceObject.location == undefined || _ctx.presentComplianceObject.location == null)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, "N/A"))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.presentComplianceObject.location, (location) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "w-auto h-6 bg-primary mb-2 mr-3 px-2 rounded-sm flex items-center text-white text-sm",
                                                  key: location
                                                }, _toDisplayString(_ctx.locationObject.find((eachLocation)=>{
                                                                return eachLocation.value == location
                                                            }).label), 1))
                                              }), 128))
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_56, [
                                      _cache[29] || (_cache[29] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Compliance Members", -1)),
                                      _createElementVNode("div", _hoisted_57, [
                                        (_ctx.presentComplianceObject.complianceMembers == '' || _ctx.presentComplianceObject.complianceMembers == [] || _ctx.presentComplianceObject.complianceMembers == undefined || _ctx.presentComplianceObject.complianceMembers == null)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, "N/A"))
                                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.presentComplianceObject.complianceMembers, (complianceMember) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "w-auto h-6 bg-primary mb-2 mr-3 px-2 rounded-sm flex items-center text-white text-sm",
                                                key: complianceMember
                                              }, _toDisplayString(_ctx.optionsUserArray.find((eachUser)=>{
                                                                return eachUser.value == complianceMember
                                                            }).label), 1))
                                            }), 128))
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (tab.id==3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _createVNode(_component_tableData, {
                              tableRowData: _ctx.teamsArray,
                              headersData: _ctx.Headers,
                              departmentArr: _ctx.teamObject,
                              locations: _ctx.locationObject,
                              loadData: _ctx.dataLoading
                            }, null, 8, ["tableRowData", "headersData", "departmentArr", "locations", "loadData"]),
                            (_ctx.toolTipActive)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                  _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (tab.id==4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("div", null, [
                              _createVNode(_component_tableData, {
                                tableRowData: _ctx.tableRow,
                                headersData: _ctx.mainHeaders,
                                departmentArr: _ctx.teamObject,
                                locations: _ctx.locationObject,
                                loadData: _ctx.dataLoading
                              }, null, 8, ["tableRowData", "headersData", "departmentArr", "locations", "loadData"]),
                              (_ctx.toolTipActive)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    (_ctx.showFindingsPopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.showFindingsPopUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_63, [
              _cache[31] || (_cache[31] = _createElementVNode("h1", null, "Findings", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
              }, _cache[30] || (_cache[30] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { class: "controllabel" }, "Finding-Id", -1)),
                      _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.ActionObj.findingId?.toUpperCase()), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", { class: "controllabel" }, "Findings", -1)),
                    _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("p", _hoisted_70, _toDisplayString(_ctx.ActionObj.finding), 1)
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "controllabel" }, "Finding related to Evidence", -1)),
                    _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("p", _hoisted_72, _toDisplayString(_ctx.ActionObj.findingEvidence), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showTerminatePopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showTerminatePopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("h1", null, "Terminate - " + _toDisplayString(_ctx.presentComplianceObject.title), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onCancelTerminate()))
              }, _cache[38] || (_cache[38] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _cache[39] || (_cache[39] = _createElementVNode("label", {
                                for: "number",
                                class: "controllabel"
                              }, "Reason/Justification for Terminating the Compliance", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                class: "inputboxstyling resize-none mt-2",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.terminateComments) = $event)),
                                placeholder: "Reason/Justification for Terminating the Compliance",
                                rows: "3"
                              }, null, 512), [
                                [_vModelText, _ctx.terminateComments]
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "checkbox cursor-pointer mr-2",
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.retainFindings) = $event)),
                              id: "retainFindings"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.retainFindings]
                            ]),
                            _cache[40] || (_cache[40] = _createElementVNode("label", {
                              for: "retainFindings",
                              class: "controllabel"
                            }, "Retain Findings", -1))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("button", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.TerminatePresentCompliance())),
                    class: _normalizeClass(_ctx.terminateComments =='' ? 'btndisabled pointer-events-none': 'btnprimary')
                  }, "Terminate", 2)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ], 2))
}